import type * as api from '@gitbook/api-client';

import {
    CommentsNavigationProvider,
    type CommentsNavigationProviderProps,
    FetchComments,
} from '../..';

export type ChangeRequestCommentsProviderProps = {
    space: api.Space;
    changeRequest: api.ChangeRequest;
} & Pick<
    CommentsNavigationProviderProps,
    'children' | 'currentPageId' | 'currentSideSheet' | 'navigateToComments'
>;

/**
 * Provide the context to fetch and ensure navigation to comments is handled correctly.
 */
export function ChangeRequestCommentsProvider(props: ChangeRequestCommentsProviderProps) {
    const { space, changeRequest, ...rest } = props;

    return (
        <FetchComments spaceId={space.id} changeRequestId={changeRequest.id}>
            <CommentsNavigationProvider
                spaceId={space.id}
                changeRequestId={changeRequest.id}
                {...rest}
            />
        </FetchComments>
    );
}
